import { useSelector } from 'react-redux';
import { selectIsAnalyticsLoaded } from '../../theme/src/modules/messages';
import { useEffect, useState } from 'react';

declare global {
  export interface Window {
    analytics: {
      track: (msg: string, body?: { [key: string]: string }) => void;
    };
    tintAnalyticsClient: {
      track: (msg: string, body?: { [key: string]: string }) => Promise<string>;
      recordTraits: (params?: { [key: string]: string }) => Promise<string>;
    };
  }
}

export const TintAnalyticsTracker = (isTrackingEnable: boolean) => {
  const _track = (
    message: string,
    body?: { [key: string]: string },
    isTrackingEnabled: boolean = isTrackingEnable
  ): void => {
    if (isTrackingEnabled && window?.tintAnalyticsClient && window.tintAnalyticsClient.track) {
      window.tintAnalyticsClient.track(message, body);
    }
  };

  const _recordTraits = (params?: { [key: string]: string }, isTrackingEnabled: boolean = isTrackingEnable): void => {
    if (isTrackingEnabled && window.tintAnalyticsClient && window.tintAnalyticsClient.recordTraits) {
      window.tintAnalyticsClient.recordTraits(params);
    }
  };

  return {
    track: (message: string, body?: { [key: string]: string }) => _track(message, body),
    recordTraits: (params?: { [key: string]: string }) => _recordTraits(params),
  };
};
